/**
 * Generates and downloads the blank Excel template used by the Vendor Master
 * MOQ/MOV upload flow. Headers match exactly the column names the backend SP
 * dbo.ImportVendorOrderType expects (VendorName, JobType, OrderType, MOQ, MOV).
 *
 * Pattern mirrors helper/downloadOrderUploadTemplate.ts — Workbook (exceljs) and
 * fs (file-saver) are injected so this helper doesn't carry hard imports of
 * those packages.
 */
export const downloadProductReplacementTemplate = (
  Workbook: any,
  fs: any
) => {
  let workbook = new Workbook();
  let worksheet = workbook.addWorksheet('Product Replacment Upload');
  let columns = getColumnDefs();
  worksheet.columns = columns as any;
  worksheet.getRow(1).font = { bold: true };
  worksheet.getRow(1).fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'cccccc' },
  };
  workbook.xlsx.writeBuffer().then((data: any) => {
    let blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    fs.saveAs(blob, `Product_Replacment_UploadTemplate_${new Date().toISOString()}.xlsx`);
  });
};

function getColumnDefs() {
  const headerStyle = {
    border: {
      top: { style: 'thin', color: { argb: '000000' } },
      left: { style: 'thin', color: { argb: '000000' } },
      bottom: { style: 'thin', color: { argb: '000000' } },
      right: { style: 'thin', color: { argb: '000000' } },
    },
    fill: {
      type: 'pattern',
      gradient: 'lightGray',
      bgColor: { argb: '808080' },
    },
  };

  const columns = [
    { header: 'Retailer', key: 'retailer', width: 12, style: headerStyle },
    { header: 'Replacement Product Code',    key: 'ReplacementProductCode',    width: 20, style: headerStyle },
    { header: 'Replacement UPC',  key: 'replacementUPC',  width: 20, style: headerStyle },
    { header: 'Replacement Vendor Product Code',        key: 'replacementVendorProductCode',        width: 30, style: headerStyle },
    { header: 'Replaced Product Code',        key: 'replaceProductCode',        width: 20, style: headerStyle },
    { header: 'Replaced UPC',        key: 'replacedUPC',        width: 20, style: headerStyle },
    { header: 'Replaced Vendor Product Code',        key: 'replacedVendorProductCode',        width: 30, style: headerStyle },
    { header: 'Stock Run Down',        key: 'stockRunDown',        width: 12, style: headerStyle },
    { header: 'Stock Run Down Value',        key: 'stockRunDownValue',        width: 12, style: headerStyle },
    { header: 'Effective End Date',        key: 'effectiveEndDate',        width: 20, style: headerStyle },
    { header: 'Replacement Type',        key: 'replacementType',        width: 20, style: headerStyle },
  ];
  return columns;
}
